// header 通知、頭像、登入註冊按鈕
import { useDispatch, useSelector } from 'react-redux';
import { userState } from '@/slices/userSlice';
import { setShowNotifyModal, setShowUserModal, popState } from '@/slices/popSlice';

import LoginButton from './LoginButton'; // 登入註冊按鈕
import HeaderNotifyButton from './HeaderNotifyButton'; // 通知按鈕
import HeaderAvatarButton from './HeaderAvatarButton'; // 頭像按鈕

const HeaderUserBlock = () => {
    const { user } = useSelector(userState);
    const { showNotifyModal } = useSelector(popState);
    const dispatch = useDispatch();

    // 點擊通知
    const onClickNotify = () => dispatch(setShowNotifyModal(!showNotifyModal));

    // 點擊頭像
    const onClickAvatar = () => dispatch(setShowUserModal(true));

    // 未登入
    if (!user?.uid) return <LoginButton />;

    return (
        <>
            {/* 通知按鈕 */}
            <HeaderNotifyButton onClickNotify={onClickNotify} uid={user?.uid} />

            {/* 頭像按鈕 */}
            <HeaderAvatarButton
                onClickAvatar={onClickAvatar}
                avatar={user?.image}
                avatarFrame={user?.avatarFrame}
            />
        </>
    );
};

export default HeaderUserBlock;
